const contactConstraints = {
  "00N2p000006x2Ad": { // country
    presence: {
      allowEmpty: false,
    },
  },
  "00N2p000006x2An": { // region
    presence: {
      allowEmpty: false,
    },
  },
  "00N2p000006x2Ai": { // language
    presence: {
      allowEmpty: false,
    },
  },
  "00D9E0000009Dpz": { // orgid
    presence: {
      allowEmpty: false,
    },
  },
  status: {
    presence: {
      allowEmpty: false,
    },
  },
  priority: {
    presence: {
      allowEmpty: false,
    },
  },
  origin: {
    presence: {
      allowEmpty: false,
    },
  },
  "0122p00000042BA": {}, // recordtype
  "00N2p000006x2AT": { // firstname
    presence: {
      allowEmpty: false,
    },
  },
  "00N2p000006x29u": { // lastname
    presence: {
      allowEmpty: false,
    },
  },
  "00N2p000006x29z": { // email
    email: true,
    presence: {
      allowEmpty: false,
    },
  },
  phone: {},
  "00N2p000006x2DZ": {}, // ordernumber
  subject: {
    presence: {
      allowEmpty: false,
    },
  },
  description: {
    presence: {
      allowEmpty: false,
    },
  }
};

export default contactConstraints;
